
import { filterByDate, filterCVEsBySeverity } from './dashboardDataProcessors';
import { getDaysAgo } from './dateUtils';
import { VulnerabilityItem } from '@/types/dashboard';

/**
 * Process CVE data into severity categories
 */
/**
 * Process CVE data into severity categories
 */
export function processCVEData(cveData: any, days: number = 30) {
  const startDate = getDaysAgo(days);
  const previousStartDate = getDaysAgo(days * 2);
  const cveArray = Array.isArray(cveData) ? cveData : [];

  console.log("CVE data for processing:", {
    isArray: Array.isArray(cveData),
    length: cveArray.length,
    sample: cveArray.length > 0 ? cveArray[0] : 'no data'
  });

  const recentCVEs = filterByDate(cveArray, 'publishedDate', startDate);

  const previousCVEs = cveArray.filter(item => {
    const date = new Date(item.publishedDate);
    return date >= previousStartDate && date < startDate;
  });

  // Helper to filter by severity
  const filterBySev = (items: any[], min: number, max: number, severity: string, severityPl: string) => {
    return filterCVEsBySeverity(items, min, max, severity, severityPl);
  };

  // Current Period
  const criticalVulnerabilities = filterBySev(recentCVEs, 9.0, 10.0, 'critical', 'krytyczna');
  const highVulnerabilities = filterBySev(recentCVEs, 7.0, 9.0, 'high', 'wysoka');
  const mediumVulnerabilities = filterBySev(recentCVEs, 4.0, 7.0, 'medium', 'średnia');
  const lowVulnerabilities = filterBySev(recentCVEs, 0.1, 4.0, 'low', 'niska');

  // Previous Period
  const prevCriticalVulnerabilities = filterBySev(previousCVEs, 9.0, 10.0, 'critical', 'krytyczna');
  const prevHighVulnerabilities = filterBySev(previousCVEs, 7.0, 9.0, 'high', 'wysoka');
  const prevMediumVulnerabilities = filterBySev(previousCVEs, 4.0, 7.0, 'medium', 'średnia');
  const prevLowVulnerabilities = filterBySev(previousCVEs, 0.1, 4.0, 'low', 'niska');

  // Prepare CVE data with proper localized fields
  const processCVEItem = (cve: any): VulnerabilityItem => {
    return {
      id: cve.id || cve.name || cve.cve_id || 'Unknown',
      name: cve.name || '',
      description: cve.description || cve.desc_en || '',
      description_pl: cve.desc_pl || cve.description_pl || '',
      score: parseFloat(cve.score) || 0,
      publishedDate: cve.publishedDate || new Date().toISOString()
    };
  };

  // Use all critical vulnerabilities for the recent list, but sort by date
  const recentCriticalVulnerabilities = [...criticalVulnerabilities]
    .sort((a, b) => {
      const dateA = new Date(a.publishedDate).getTime();
      const dateB = new Date(b.publishedDate).getTime();
      return dateB - dateA; // Sort by most recent first
    })
    .map(processCVEItem)
    .slice(0, 5) as VulnerabilityItem[]; // Only take the top 5

  return {
    criticalVulnerabilities,
    highVulnerabilities,
    mediumVulnerabilities,
    lowVulnerabilities,
    recentCriticalVulnerabilities,
    // Return counts for previous period
    prevCriticalCount: prevCriticalVulnerabilities.length,
    prevHighCount: prevHighVulnerabilities.length,
    prevMediumCount: prevMediumVulnerabilities.length,
    prevLowCount: prevLowVulnerabilities.length
  };
}
